import { render, staticRenderFns } from "./intserv.vue?vue&type=template&id=bfdbc874&scoped=true"
import script from "./intserv.vue?vue&type=script&lang=js"
export * from "./intserv.vue?vue&type=script&lang=js"
import style0 from "./intserv.vue?vue&type=style&index=0&id=bfdbc874&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfdbc874",
  null
  
)

export default component.exports